var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudittrail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M9 27.9C7.1 24.3 6.8 20 8.4 16c2.9-7.5 11.4-11.2 18.9-8.3s11.2 11.4 8.2 18.8c-2.4 6.2-8.6 9.8-14.9 9.2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot_x0020_12",
    cx: 15.4,
    cy: 33.8,
    r: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M29.9 22.3h-9.3V14M12.8 25.6L10 31.1l-5.5-2.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudittrail);
export default __webpack_public_path__ + "static/media/audittrail.664d70a9b3a527c80ff7da044946ba9c.svg";
export { ForwardRef as ReactComponent };